@if (enableBanner) {
  <header>
    <h3 class="header-important-info-banner">
      {{ "header.banner-text" | translate }}
    </h3>
  </header>
}

<app-toast-wrapper />

<header *ngIf="currentLang" class="app-header-wrapper">
  <div class="app-header-wrapper_logo" routerLink="/">
    <img ngSrc="assets/images/ar_logo.png" alt="" width="124" height="147" />
  </div>

  <div class="app-header-wrapper_nav-lang-w">
    <!-- Hamburger icon for mobile -->
    <div class="_mobile-menu-icon" (click)="toggleMobileMenu()">
      <img src="assets/images/hamburger-menu.png" alt="menu" />
    </div>

    <div class="_nav-div-w" [ngClass]="isMobileMenuOpen ? '_nav-w-open' : ''">
      <nav>
        <ul>
          <li (click)="setActiveHeaderNav('services')" routerLink="/services">
            <a
              [ngClass]="activeHeaderNav === 'services' ? '_active-nav' : ''"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              >{{ "header.services" | translate }}</a
            >
            <img
              src="assets/svgs/icons/our-services-icon.svg"
              alt="Phone call"
            />
          </li>
          <li (click)="setActiveHeaderNav('about')" routerLink="/about">
            <a
              [ngClass]="activeHeaderNav === 'about' ? '_active-nav' : ''"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              >{{ "header.about" | translate }}</a
            >
            <img src="assets/svgs/icons/about-us-icon.svg" alt="Phone call" />
          </li>
          <li
            (click)="setActiveHeaderNav('contact-us')"
            routerLink="/contact-us"
          >
            <a
              [ngClass]="activeHeaderNav === 'contact-us' ? '_active-nav' : ''"
              routerLinkActive="active"
              ariaCurrentWhenActive="page"
              >{{ "header.contact" | translate }}</a
            >
            <img src="assets/svgs/icons/call-icon.svg" style="color: #fff;" alt="Phone call" />
          </li>
          <li>
            <app-button
              [label]="'header.consultation' | translate"
              class="consultation-button"
              [href]="'/consultation'"
              (click)="setActiveHeaderNav('consultation')"
            />
          </li>
          <li (click)="toggleTheme()">
            <a routerLinkActive="active" ariaCurrentWhenActive="page">
              {{ "header.theme" | translate }}
            </a>

            <img
              [src]="
                isDarkTheme()
                  ? 'assets/svgs/icons/theme-on-icon.svg'
                  : 'assets/svgs/icons/theme-off-icon.svg'
              "
              alt="Theme toggle"
            />
          </li>
        </ul>
      </nav>
    </div>

    <div class="_lang-w">
      <img
        [ngSrc]="'assets/svgs/flags/' + currentFlagIcon"
        [alt]="currentFlagIcon"
        width="25"
        height="25"
      />
      <select
        [(ngModel)]="currentLang"
        (ngModelChange)="switchLanguage($event)"
      >
        <option *ngFor="let lang of languages" [value]="lang">
          {{ lang | uppercase }}
        </option>
      </select>
    </div>
  </div>
</header>
